module.exports = __webpack_public_path__ + "img/join_2.5710461a.png";